<template>
  <div class="columns">
    <div class="column is-8 is-offset-2 content">
      <div class="box">
        <h1>{{ title }}</h1>
      </div>
      <article
        v-for="post in blogPosts"
        :key="post.id"
        class="content blog box"
      >
        <nuxt-link
          :to="localePath({ name: 'portal-blog-slug', params: { slug: post.slug || ' ' } })"
          class="link"
        >
          <h2 class="has-text-primary">
            {{ post.title }}
          <!-- <small class="has-text-grey is-size-6">{{formatDateShort(post.dateAndTime)}}</small> -->
          </h2>
          <div
            style="color: #052d40"
            v-html="$md.render(post.teaserText)"
          />
        </nuxt-link>
        <hr class="mt-50 mb-50">
      </article>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { cached } from '~/lib/cache'

/* TODO #9539
 * Pagination does not work correctly.
 * $first and $skip are applied on the full collection instead of the result set.
*/
const POSTS_PER_PAGE = 100
const allPosts = gql`
  query blogPosts(
    $first: Int!,
    $skip: Int!
  ) {
    blogPosts(
      stage: PUBLISHED,
      first: $first,
      skip: $skip,
      orderBy: dateAndTime_DESC
    ) {
      slug
      language
      title
      teaserText
      postDescription
      dateAndTime
      postMedia {
        url
        fileName
        mimeType
      }
    }
  }
`

export default {
  layout: 'static',

  // define local data
  data: () => ({
    title: 'Blog',
    blogPosts: []
  }),

  // @todo: used to wtf?
  scrollToTop: true,

  // expose data to head of website
  // @note: error function returns 'undefined'!
  head() {
    return {
      title: this.title
    }
  },

  async asyncData({ app, route, req }) {
    const language = app.i18n.locale === 'de' ? 'Deutsch' : 'Englisch'
    const { data } = await cached(
      'allBlogPosts',
      app.apolloProvider.clients.blog.query,
      {
        query: allPosts,
        variables: { skip: 0, first: POSTS_PER_PAGE }
      },
      req
    )
    return { blogPosts: data.blogPosts.filter(p => p.language === language) }
  }
}
</script>
<style lang="scss">
.content.blog {
  figure {
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
  }
}
</style>
